import React from 'react';

export const Bar = ({ stat, max }) => {
    let size = (stat.value / max) * 100;
    let targetPos = stat.target ? (stat.target / max) * 100 : null;

    return (
        <li className="stats-graph__bar-wrap">
            <div className="stats-graph__value">
                <span className="u-sr-only">Value of</span>
                {stat.value.toLocaleString()}
            </div>
            <div className="stats-graph__bar">
                <div className="stats-graph__bar-fill" style={{ height: `${size}%` }}></div>
                {targetPos && <div className="stats-graph__bar-target" style={{ bottom: `${targetPos}%` }}></div>}
            </div>
            <div className="stats-graph__label">
                <span className="u-sr-only">for the year</span>
                {stat.label}
            </div>
        </li>
    );
};

export const BarGraph = ({ data, label }) => {
    //Determine max
    const values = data.map((dataEntry) => dataEntry.value);
    const targets = data.map((dataEntry) => (dataEntry.target ? dataEntry.target : null));
    const maxValues = targets && targets.length > 0 ? [...values, ...targets] : values;

    const max = Math.max(...maxValues);

    return (
        <>
            <span className="u-sr-only">Statistics graph about {label}</span>
            <ul className="stats-graph">
                {data.map((entry, index) => (
                    <Bar key={`${label.replace(' ', '-').toLowerCase()}-${index}`} stat={entry} max={max} />
                ))}
            </ul>
        </>
    );
};
